var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import i18n from "../../../strings/i18n";
import { AutopaySectionButton, AutopaySectionContent, AutopaySectionIconWrapper, AutopaySectionWrap, } from "./AutopaySection.styles";
import { useConfig } from "../../../hooks/useConfig";
import { IMAGE_AUTOPAY_ICON } from "../../../const/assets";
var AutopaySection = function (_a) {
    var autopayEnrollment = _a.autopayEnrollment, handleAutopayClick = _a.handleAutopayClick;
    var hosts = useConfig().hosts;
    var imageSource = "".concat(hosts === null || hosts === void 0 ? void 0 : hosts.assets).concat(IMAGE_AUTOPAY_ICON);
    return (_jsxs(AutopaySectionWrap, { children: [_jsxs(AutopaySectionContent, { children: [_jsx(AutopaySectionIconWrapper, { children: _jsx("img", { src: imageSource, alt: "" }) }), autopayEnrollment ? (_jsx(_Fragment, { children: i18n({ autopay: "enrolled" }) })) : (_jsx(_Fragment, { children: i18n({ autopay: "notEnrolled" }) }))] }), _jsx(AutopaySectionButton, __assign({ buttonType: "text", onClick: handleAutopayClick, "data-analytics": "clicktrackingevent", "data-object": "button", "data-type": "pay as guest", "data-reason": autopayEnrollment ? "manage autopay" : "enroll autopay" }, { children: autopayEnrollment ? (_jsx(_Fragment, { children: i18n({ autopay: "manageButtonText" }) })) : (_jsx(_Fragment, { children: i18n({ autopay: "enrollButtonText" }) })) }))] }));
};
export default AutopaySection;
//# sourceMappingURL=AutopaySection.js.map